import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useConditionalSubmit from '../../../../../hooks/useConditionalSubmit';
import {
  getCanBeDonated,
  getCanBeExchanged,
  getGiftGl,
  getIsDonationProduct,
} from '../../../store/data/data.selectors';
import { getIsPreview } from '../../../store/statuses/statuses.selectors';
import StyledSecondaryButton from '../../../../../components/Shared/StyledSecondaryButton';

export interface IDonateButtonProps {
  onSubmit: () => void;
}

const DonateButton = ({ onSubmit }: IDonateButtonProps): JSX.Element => {
  const gl = useSelector(getGiftGl);
  const isDonation = useSelector(getIsDonationProduct);
  const isPreview = useSelector(getIsPreview);
  const canBeExchange = useSelector(getCanBeExchanged);
  const canBeDonated = useSelector(getCanBeDonated);

  const buttonText = useMemo(() => {
    if (isDonation && canBeDonated && !canBeExchange) {
      return 'Choose a different organization';
    }
    if (isDonation) {
      return 'Pick another charity';
    }
    return `Donate ${gl} value`;
  }, [isDonation, canBeExchange, canBeDonated, gl]);

  const submitHandler = useConditionalSubmit(!isPreview, onSubmit);

  return (
    <StyledSecondaryButton data-testid="giftDonateButton" onClick={submitHandler}>
      {buttonText}
    </StyledSecondaryButton>
  );
};

export default memo<IDonateButtonProps>(DonateButton);
